/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcCostbasisV1TaxLotEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_COSTBASIS_V1_TAX_LOT_EVENT_ENTITY_NAME = 'ixc.costbasis.v1.TaxLotEvent';
export const ixcCostbasisV1TaxLotEventEntity = new schema.Entity<IxcCostbasisV1TaxLotEvent>(IXC_COSTBASIS_V1_TAX_LOT_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcCostbasisV1TaxLotEvent) => `${entity.metadata?.eventId}` });

